import { Component, Input, OnInit, Output, EventEmitter, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { IInsurance } from 'src/app/models/common/insurance';
import { TwoFactorAuthModel } from 'src/app/models/common/two-fact-auth-model';
import { AuthService } from 'src/app/services/auth.service';
import { BaseControlValueAccessor } from '../form-fields/base_control_value_accessor/base';
import { InsuranceModel } from '../external-dashboards/quoteTable/base-quote.model';

export interface data {
  name: string;
  subname?: string;
  price?: string;
  pay?: string;
  details: string;
  recommended: boolean;
}

@Component({
  selector: 'mat-radio-card',
  templateUrl: './mat-radio-card.component.html',
  styleUrls: ['./mat-radio-card.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => MatRadioCardComponent),
    }
  ]
})
export class MatRadioCardComponent extends BaseControlValueAccessor implements OnInit {
  @Input()
  radioData: data[] = [];

  @Input()
  options = []

  @Input()
  insList: InsuranceModel[] = [];

  // @Input()
  // insurance: InsuranceModel;

  item: TwoFactorAuthModel = {
    id: '',
    updated_at: undefined,
    created_at: undefined,
    is_active: false,
    name: '',
    is_recommended: false,
    description: '',
    dev_name: '',
    is_forced: false,
    created_by: '',
    updated_by: '',
    logo: ''
  };

  @Output()
  onDataChange = new EventEmitter()

  pushData(value) {
    if (value != null) {
      this.onDataChange.emit(value);
      this.item = value;
    }
  }

  constructor(private authService: AuthService) {
    super();
  }

  ngOnInit(): void {
    if (this.options?.length) {
      this.getActive2FAuth();
    }
  }

  getActive2FAuth() {
    this.authService.getActiveTwoFactAuth().subscribe({
      next: response => {
        if (this.options != null) {
          for (let i = 0; i < this.options.length; i++) {
            if (response.id == this.options[i].id) {
              this.item = this.options[i];
            }
          }
        }
      },
      error: error => {
        console.log(error)
        return error;
      }
    })
  }

  ngOnChanges() {
    if (this.insList != null) {
      if (this.insList?.length) {
        for (let i = 0; i < this.insList.length; i++) {
          if (this.data?.id == this.insList[i].id) {
            this.data = this.insList[i];
          }
        }
      }
    }
  }

  pushInsuranceData(event) {
    if (event != null) {
      this.data = event;
    }
  }
}
